// @ts-nocheck
import React, { useEffect, useState, useCallback } from "react";
import { Props } from "./FormPayment.model";
import {
  PUBLIC_KEY,
  URL_ENDPOINT,
  URL_IS_VALID_PAYMENT,
} from "../../../constants/constants";
import KRGlue from "@lyracom/embedded-form-glue";
import axios from "axios";
import { CreateUserIfNoExistsAndActivateLevels } from "../../../apis/User/indexv2";
import {
  Alert,
  AlertTitle,
  Backdrop,
  CircularProgress,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import { DialogSuccess } from "./DialogSuccess.component";
import { DialogError } from "./DialogError.component";
import { useHistory } from "react-router-dom";

import { CheckoutFormProvider, CheckoutForm, useCheckoutForm } from "@stripe/react-stripe-js/checkout";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_TOKEN } from "../../../constants/constants";
const stripePromise = loadStripe(STRIPE_TOKEN);

const FormPaymentContent = (props: Props) => {
  const history = useHistory();
  
  const checkoutState = useCheckoutForm();
  const [isError, setIsError] = useState(false);

  const onConfirm = useCallback(
    async (event) => {
      if (checkoutState.type === "success") {
        try {
          const url = `https://app-radi.vercel.app/payment/order/${props.orderId}`;
          await checkoutState.checkout.confirm({ formConfirmEvent: event, returnUrl: url });
        } catch (error) {
          setIsError(true);
        }
      }
    },
    [checkoutState.checkout, checkoutState.type, props.orderId],
  );

  return (
    <>
      <Stack spacing={4}>
        <Typography variant="h6" textAlign="center">
          Completa la siguiente información para finalizar&#160;la&#160;compra
        </Typography>
        <Stack spacing={2}>
          <div>
            <CheckoutForm onConfirm={onConfirm} />
          </div>
        </Stack>
      </Stack>
      <DialogError
        open={isError}
        onReattempt={() => {
          history.replace(`/checkout/${props.publicId}`);
        }}
      />
    </>
  );
};

const FormPayment = (props: Props) => {
  return (
    <CheckoutFormProvider
      stripe={stripePromise}
      options={{ clientSecret: props.formToken }}
    >
      <FormPaymentContent {...props} />
    </CheckoutFormProvider>
  );
};

export { FormPayment };
